import gsap from "gsap";

export default class MeasureImpactAccordion {
  constructor(container) {
    this.DOM = { container };
    this.DOM.rows = this.DOM.container.querySelectorAll(".measure-impact__row");

    if (!this.DOM.rows || !this.DOM.rows.length) {
      console.warn("MeasureImpactAccordion: No rows found");
      return;
    }

    this.init();
    this.bindEvents();
  }

  init() {
    // Close all rows initially
    this.DOM.rows.forEach((row) => {
      const body = row.querySelector(".measure-impact__row-body");
      if (body) {
        gsap.set(body, { height: 0, overflow: "hidden" });
        row.classList.remove("--open");
      }
    });

    console.log(
      "MeasureImpactAccordion: Initialized",
      this.DOM.rows.length,
      "rows"
    );
  }

  bindEvents() {
    this.DOM.rows.forEach((row) => {
      const header = row.querySelector(".measure-impact__row-head");
      if (header) {
        header.style.cursor = "pointer";
        header.addEventListener("click", () => this.toggleRow(row));
      }
    });
  }

  toggleRow(targetRow) {
    const isOpen = targetRow.classList.contains("--open");
    const targetBody = targetRow.querySelector(".measure-impact__row-body");
    const targetIcon = targetRow.querySelector(".measure-impact__row-head svg");

    if (!targetBody) return;

    // Close all other rows
    this.DOM.rows.forEach((row) => {
      if (row !== targetRow && row.classList.contains("--open")) {
        const body = row.querySelector(".measure-impact__row-body");
        const icon = row.querySelector(".measure-impact__row-head svg");

        row.classList.remove("--open");

        gsap.to(body, {
          height: 0,
          duration: 0.4,
          ease: "power2.inOut",
        });

        if (icon) {
          gsap.to(icon, {
            rotation: 0,
            duration: 0.3,
            ease: "power2.inOut",
          });
        }
      }
    });

    // Toggle the clicked row
    if (isOpen) {
      // Close it
      targetRow.classList.remove("--open");

      gsap.to(targetBody, {
        height: 0,
        duration: 0.4,
        ease: "power2.inOut",
      });

      if (targetIcon) {
        gsap.to(targetIcon, {
          rotation: 0,
          duration: 0.3,
          ease: "power2.inOut",
        });
      }
    } else {
      // Open it
      targetRow.classList.add("--open");

      const fullHeight = targetBody.scrollHeight;

      gsap.to(targetBody, {
        height: fullHeight,
        duration: 0.4,
        ease: "power2.inOut",
      });

      if (targetIcon) {
        gsap.to(targetIcon, {
          rotation: 180,
          duration: 0.3,
          ease: "power2.inOut",
        });
      }
    }
  }

  destroy() {
    // Remove event listeners
    this.DOM.rows.forEach((row) => {
      const header = row.querySelector(".measure-impact__row-head");
      if (header) {
        header.style.cursor = "";
        header.removeEventListener("click", this.toggleRow);
      }
    });
  }
}
